// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"b3741854","651":"b07d9c9e","746":"249733f3","858":"85ed9e45"}[chunkId] + ".chunk.js";
};